/* eslint-disable import/prefer-default-export */
export const DELIVERY_PACKAGE_IS_OVERWEIGHT = 'DELIVERY_PACKAGE_IS_OVERWEIGHT';